<template xmlns:v-on="http://www.w3.org/1999/xhtml">
    <v-layout>
        <v-runtime-template v-if="modelingHtml" :template="'<div>' + modelingHtml + '</div>'"/>

        <v-progress-circular
                v-else
                :size="50"
                color="primary"
                indeterminate
        ></v-progress-circular>

    </v-layout>
</template>

<script>
    import VRuntimeTemplate from "v-runtime-template";
    import EventStormingModelReplay from "../es-modeling/EventStormingModelReplay";
    // import StorageBase from "./StorageBase";
    import StorageBase from "./ModelStorageBase";

    var jp = require('jsonpath');

    export default {
        name: 'replay-portal',
        props: {},
        mixins: [StorageBase],
        components: {VRuntimeTemplate},
        data() {
            return {
                modelingHtml: null,
                information: null,
                projectName: '',
                projectId: null,
                snapshotKey: null,
                queueKey: null,
            }
        },
        created: async function () {
            var me = this
            me.projectId = me.$route.params.projectId
            me.snapshotKey = me.$route.params.snapshotKey
            me.queueKey = me.$route.params.queueKey
            me.information = await me.getString(`db://definitions/${me.projectId}/information`)

            Vue.component('event-storming-model-replay', EventStormingModelReplay)

            if (me.information.type == 'es') {
                me.projectName = me.information.projectName
                me.modelingHtml = '<event-storming-model-replay :projectName="projectName"> </event-storming-model-replay>'
            } else {
                alert('현재 모델링은 준비중 입니다.')
            }


        },
        computed: {},
        watch: {},
        methods: {}
    }
</script>


<style scoped lang="css" rel="stylesheet/css">


    .canvas-panel.small {
        left: 0;
        right: 0;
        width: 83%;
        height: 100%;
        position: absolute;
        overflow: hidden;

        /*transform: scale(0.5) translate(-50%, -50%);*/
    }

</style>

